export default {"src":"/_next/static/media/group.d9bff7f4.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};